import $ from 'jquery';

$('.js-form-autosubmit').on('change', 'input', (event) => {
    event.delegateTarget.submit();
});
